import React from 'react';
import StaffMemberPage from './StaffMemberPage';

/**
 * Pagina "Il mio profilo" per Store User / Store Manager.
 * Riusa StaffMemberPage con selfMode={true} (chiama /api/staff/me).
 */
export default function MyProfilePage() {
  return <StaffMemberPage selfMode={true} />;
}
